import { render, staticRenderFns } from "./MarqetaActivateCardHosted.vue?vue&type=template&id=02b8032e&scoped=true"
import script from "./MarqetaActivateCardHosted.vue?vue&type=script&lang=js"
export * from "./MarqetaActivateCardHosted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8032e",
  null
  
)

export default component.exports